import { Component, ViewEncapsulation } from '@angular/core';
import { SavedCartFormDialogComponent } from '@spartacus/cart/saved-cart/components';
import { SavedCartFormType } from '@spartacus/cart/saved-cart/root';
import { CheckoutQueryResetEvent } from "@spartacus/checkout/base/root";
import { GlobalMessageType } from '@spartacus/core';

@Component({
    selector: 'app-uig-saved-cart-form-dialog',
    templateUrl: './uig-saved-cart-form-dialog.component.html',
    styleUrls: ['./uig-saved-cart-form-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigSavedCartFormDialogComponent extends SavedCartFormDialogComponent {

  onComplete(success: boolean): void {
    if (success) {
      switch (this.layoutOption) {
        case SavedCartFormType.DELETE: {
          this.close('Successfully deleted a saved cart');
          this.routingService.go({ cxRoute: 'savedCarts' });
          this.globalMessageService.add(
            {
              key: 'customSavedCartDialog.deleteCartSuccess',
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );

          break;
        }

        case SavedCartFormType.SAVE: {
          this.close('Successfully saved cart');
          this.eventService.dispatch({}, CheckoutQueryResetEvent);
          this.savedCartService.clearSaveCart();

          this.globalMessageService.add(
            {
              key: 'customSavedCartPage.messages.cartSaved',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code,
              },
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );

          break;
        }

        case SavedCartFormType.EDIT: {
          this.close('Successfully edited saved cart');
          this.savedCartService.clearSaveCart();
          this.globalMessageService.add(
            {
              key: 'customSavedCartDialog.editCartSuccess',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code,
              },
            },

            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );

          break;
        }
      }
    }
  }


}
